import React from 'react';

export default class CommissionManagement extends React.Component {
  render() {
    // TODO commission management
    return <div>commission management</div>;
  }
}
